import { render, staticRenderFns } from "./APMAAssignTaskDetail.vue?vue&type=template&id=674dc3c3&"
import script from "./APMAAssignTaskDetail.vue?vue&type=script&lang=js&"
export * from "./APMAAssignTaskDetail.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports